import cognitoApi from './cognitoAPI.js';

function OccoApi() {
    this.userListRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/user/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.organisationListRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/organisation/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    //organisationId is optional
    this.robotListRetrieve = function (organisationId, callback) {
        var body = {};
        if (organisationId) {
            body.organisation_id = organisationId;
        }
        var methodPath = "/occo-owner/robot/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.stockImageListRetrieve = function (eventId, callback) {
  /*      var body = {};
        if (eventId) {
            body.event_id = eventId;
        }
        var methodPath = "/occo-owner/stock-image/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    */};

    this.organisationCreate = function (name, email, phone, siteUrl, address, removal_ai_api_key, removal_pw_api_key, enableIP, callback) {
        var body = {};
        body.name = name;
        body.email = email;
        body.phone = phone;
        body.site_url = siteUrl;
        body.address = address;
        body.removal_ai_api_key = removal_ai_api_key;
        body.removal_pw_api_key = removal_pw_api_key;
        body.enable_image_process = enableIP;
        var methodPath = "/occo-owner/organisation/create";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.organisationUpdate = function (id, name, email, phone, siteUrl, address, removal_ai_api_key, removal_pw_api_key, enableIP, callback) {
        var body = {};
        body.id = id;
        body.name = name;
        body.email = email;
        body.phone = phone;
        body.site_url = siteUrl;
        body.address = address;
        body.removal_ai_api_key = removal_ai_api_key;
        body.removal_pw_api_key = removal_pw_api_key;
        body.enable_image_process = enableIP;
        var methodPath = "/occo-owner/organisation/update";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.userCreate = function (firstName, lastName, username, email, organisationId, roleId, callback) {
        var body = {};
        body.first_name = firstName;
        body.last_name = lastName;
        body.username = username;
        body.email = email;
        body.organisation_id = organisationId;
        body.role_id = roleId;
        var methodPath = "/occo-owner/user/create";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.robotCreate = function (name, organisationId, beaconList, minLatitude, maxLatitude, minLongitude, maxLongitude, callback) {
        var body = {};
        body.name = name;
        body.organisation_id = organisationId;
        body.beacon_id_array = beaconList;
        body.min_latitude = minLatitude;
        body.max_latitude = maxLatitude;
        body.min_longitude = minLongitude;
        body.max_longitude = maxLongitude;
        var methodPath = "/occo-owner/robot/create";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.robotUpdate = function (id, name, organisationId, beaconList, minLatitude, maxLatitude, minLongitude, maxLongitude, callback) {
        var body = {};
        body.id = id;
        body.name = name;
        body.organisation_id = organisationId;
        body.beacon_id_array = beaconList;
        body.min_latitude = minLatitude;
        body.max_latitude = maxLatitude;
        body.min_longitude = minLongitude;
        body.max_longitude = maxLongitude;
        var methodPath = "/occo-owner/robot/update";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };



    this.userUpdate = function (id, firstName, lastName, roleId, organisationId, email, callback) {
        var body = {};
        body.id = id;
        body.first_name = firstName;
        body.last_name = lastName;
        body.role_id = roleId;
        body.organisation_id = organisationId;
        body.email = email;
        var methodPath = "/occo-owner/user/update";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.userMyInfoRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/user/my-info/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.robotSettingsRetrieve = function (robotId, callback) {
        var body = {};
        body.robot_id = robotId;
        var methodPath = "/occo-owner/robot/settings/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.mobileSettingsUpdate = function (appConfig, callback) {
        var body = {};
        body.app_configs = appConfig;
        var methodPath = "/occo-owner/mobile-app-settings/update";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.mobileSettingsRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/mobile-app-settings/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };


    this.userDelete = function (id, callback) {
        var body = {};
        body.id = id;
        var methodPath = "/occo-owner/user/delete";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.organisationDelete = function (id, callback) {
        var body = {};
        body.id = id;
        var methodPath = "/occo-owner/organisation/delete";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.robotDelete = function (id, callback) {
        var body = {};
        body.id = id;
        var methodPath = "/occo-owner/robot/delete";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.robotSettingsUpdate = function (robotId, state, callback) {
        var body = {};
        body.robot_id = robotId;
        body.state = state;
        var methodPath = "/occo-owner/robot/settings/update";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.eventListRetrieve = function (organisationId, callback) {
        var body = {};
        if (organisationId) {
            body.organisation_id = organisationId;
        }
        body.max_size = 5000;
        body.page_number = 1;
        var methodPath = "/occo-owner/event/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.photoTmpUploadAccessRetrieve = function (fileRelativePath, callback) {
        var body = {};
        body.file_relative_path = fileRelativePath;
        var methodPath = "/occo-owner/photo/tmp-upload-access/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.assetTmpUploadAccessRetrieve = function (fileRelativePath, callback) {
        var body = {};
        body.file_relative_path = fileRelativePath;
        var methodPath = "/occo-owner/asset/tmp-upload-access/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    //Cloud Processing
    this.imageProcessCreate = function (body, callback) {
        const methodPath = "/occo-owner/image-process/create";
        const hasApiKey = true;
        const showApiErrors = true;
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };

    this.imageProcessUpdate = function (id, body, callback) {
        body.id = id;
        const methodPath = "/occo-owner/image-process/update";
        const hasApiKey = true;
        const showApiErrors = true;
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    }

    this.imageProcessDelete = function (id, callback) {
        const body = { id: id };
        const methodPath = "/occo-owner/image-process/delete";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.imageProcessListRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/image-process/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.imgProcSampleListRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/sample-image-process/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.imagePreview = function (body, callback) {
        var methodPath = "/occo-owner/process-image-preview";
        var hasApiKey = true;
        var showApiErrors = true;
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };

    //Beacon Management
    this.beaconListRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/beacon/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.beaconCreate = function (name, majorName, minorName, maxRssiName, minRssiName, uuidName, robotId, callback) {
        var body = {};
        body.name = name;
        body.major = majorName;
        body.minor = minorName;
        body.max_rssi = maxRssiName;
        body.min_rssi = minRssiName;
        body.uuid = uuidName;
        body.robot_id = robotId;
        var methodPath = "/occo-owner/beacon/create";
        var hasApiKey = true;
        var showApiErrors = true;
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };

    this.beaconUpdate = function (id, name, majorName, minorName, maxRssiName, minRssiName, uuidName, robotId, callback) {
        var body = {};
        body.id = id;
        body.name = name;
        body.major = majorName;
        body.minor = minorName;
        body.max_rssi = maxRssiName;
        body.min_rssi = minRssiName;
        body.uuid = uuidName;
        body.robot_id = robotId;
        var methodPath = "/occo-owner/beacon/update";
        var hasApiKey = true;
        var showApiErrors = true;
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };
    this.beaconDelete = function (id, callback) {
        var body = {};
        body.id = id;
        var methodPath = "/occo-owner/beacon/delete";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.createReport = function (type, organisation_id, event_id, start_date, end_date, email, callback) {
        var body = {};
        body.type = type;
        body.start_date = start_date;
        body.end_date = end_date;
        body.organisation_id = organisation_id;
        body.event_id = event_id;
        body.email = email;
        var methodPath = "/occo-owner/report/create";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    this.lifecycleListRetrieve = function (callback) {
        var body = {};
        var methodPath = "/occo-owner/lifecycle/list/retrieve";
        var hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };

    function _occoApiPostRequest(hasApiKey, methodPath, body, callback) {
        _occoApiPostRequestBase(hasApiKey, methodPath, body, false, callback);
    }

    function _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback) {
        const showErr = hasApiKey || showApiErrors || window.DEBUG_MODE;
        var ajaxParams = {
            url: window.BACKEND_API + methodPath,
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(body),

            success: function (resp, textStatus, jqXHR) {
                if (resp.status == "ok") {
                    callback(null, resp.result);
                } else if (resp.status == "nok") {
                    var err1 = {};
                    err1.type = "occo";
                    err1.message_key = showErr ? resp.error_message_key : "Internal Error";
                    err1.message_text = showErr ? resp.error.message_text : "Internal Error";
                    err1.textStatus = textStatus;
                    err1.jqXHR = jqXHR;
                    err1.resp = resp;
                    console.error("err", JSON.stringify(err1));
                    callback(err1, null);
                } else {
                    var err2 = {};
                    err2.type = "occo";
                    err2.message_key = "Internal Error";
                    err2.jqXHR = jqXHR;
                    err2.textStatus = textStatus;
                    err2.resp = resp;
                    console.error("err", JSON.stringify(err2));
                    callback(err2, null);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // if (jqXHR.readyState == 0 || jqXHR.status == 0) {
                //     return false; // it's not really an error,
                //     //it's accure when user refresh page before ajax call complition
                // }
                var err = {};
                err.type = "global";
                err.message_key = "Internal Error";
                err.jqXHR = jqXHR;
                err.textStatus = textStatus;
                err.errorThrown = errorThrown;
                console.error("err", JSON.stringify(err));
                callback(err, null);
            }
        };
        if (hasApiKey) {
            cognitoApi.getApiKey(function (err, apiKey) {
                if (err) {
                    location.href = "./";
                    //callback(err, null);
                    return;
                }
                ajaxParams.headers = {
                    'Authorization': apiKey
                };
                $.ajax(ajaxParams);
            });
        } else {
            $.ajax(ajaxParams);
        }
    }
}
var occoApi = new OccoApi();
export default occoApi;